import {FC} from 'react';
import {Icon, Popup, PopupProps} from 'semantic-ui-react';
import {find, get} from 'lodash';

type PredefinedEntityIconProps = {
  predefinedEntities: any[];
  predefinedEntityName: string;
  predefinedEntityType: string;
  trigger?: PopupProps['trigger'];
};

const PredefinedEntityIcon: FC<PredefinedEntityIconProps> = ({
  predefinedEntities, predefinedEntityName, predefinedEntityType, trigger = <Icon name='box' />
}) => {
  const predefinedEntityLabel = get(
    find(predefinedEntities, {name: predefinedEntityName}),
    ['schema', 'properties', 'label', 'default'],
    predefinedEntityName
  );

  return (
    <Popup
      trigger={trigger}
      size='tiny'
      position='right center'
      header={predefinedEntityLabel}
      content={predefinedEntityType}
    />
  );
};

export default PredefinedEntityIcon;
